import { Pipe, PipeTransform } from '@angular/core';
import { Project } from '@macs-frontend/features/shared/models/project';
import { ProjectCalculations } from '@macs-frontend/features/shared/utils/project-calculations';

@Pipe({ name: 'projectEstimatedAbsoluteMargin', pure: true })
export class ProjectEstimatedAbsoluteMarginPipe implements PipeTransform {
  public transform(project: Project): number {
    return ProjectCalculations.getEstimatedAbsoluteMargin(project);
  }
}
